import { PortableTextReactComponents } from "next-sanity";
import Link from "next/link";
import { Check } from "../icons/check";
import { Button } from "../ui/button";
import { iconsMap } from "../icons";
import { getURL, SanityButtonType } from "@/lib/utils";

const Heading = ({ children }: { children?: React.ReactNode }) => (
  <h4 className="font-medium text-sm lg:text-3xl lg:text-primary">
    {children}
  </h4>
);

export const ButtonComponent = ({ value }: { value: SanityButtonType }) => {
  const href = getURL(value);
  return (
    <Button
      variant={value.variant}
      radius="full"
      className="w-fit mt-4"
      asChild={value.link ? true : false}
    >
      {value.link ? (
        <Link href={href}>
          {value.textBeforeIcon}
          {value.icon && iconsMap[value.icon]}
          {value.textAfterIcon}
        </Link>
      ) : (
        <>
          {value.textBeforeIcon}
          {value.icon && iconsMap[value.icon]}
          {value.textAfterIcon}
        </>
      )}
    </Button>
  );
};

export const components: Partial<PortableTextReactComponents> = {
  block: {
    normal: ({ children }) => (
      <p className="leading-7 [&:not(:first-child)]:mt-6 dark text-primary-text-900 line-clamp-6">
        {children}
      </p>
    ),
    title: Heading,
    h4: Heading,
  },
  marks: {
    link: ({ children, value }) => (
      <Link href={value.href} className="no-underline text-primary-400">
        {children}
      </Link>
    ),
    strong: ({ children }) => (
      <strong className="font-medium text-[#0B0B0B]">{children}</strong>
    ),
  },
  list: {
    bullet: ({ children }) => (
      <ul className="ml-0 my-6 list-disc [&>li]:mt-2">{children}</ul>
    ),
  },
  listItem: {
    bullet: ({ children }) => (
      <li className="list-none flex flex-row gap-2 leading-7">
        <div className="text-lg border-primary-500 rounded-full border w-8 h-8 text-primary-500 flex items-center justify-center shrink-0">
          <Check />
        </div>
        <p className="leading-7 text-primary-text-900 dark">{children}</p>
      </li>
    ),
  },
  types: {
    button: ButtonComponent,
  },
};
